
import { NOTIFICATION_GET } from "../Constants/NotificationConstants";
import { createGetDataReducer } from "./CommonReducer";

const NotificationGetReducer = createGetDataReducer(NOTIFICATION_GET);




export const NotificationReducers = {
    NotificationGetState: NotificationGetReducer,



}